import React, { FunctionComponent } from "react";
import BaseCard, { BaseCardProps } from "../base";
import CardHorizontalLayout from "./CardHorizontalLayout";

export type CardBasicHorizontalType = Omit<
  BaseCardProps,
  "layout" | "renderLayout"
>;

export const CardBasicHorizontal: FunctionComponent<CardBasicHorizontalType> = (
  props
) => {
  return (
    <BaseCard
      {...props}
      layout="horizontal"
      renderLayout={(renderProps) => <CardHorizontalLayout {...renderProps} />}
    />
  );
};

export default CardBasicHorizontal;
